import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl-next';

import { MergeCheck, MergeCheckKey } from 'src/types';

import { classicCheckMessages, messages } from '../i18n';

type ClassicMergeCheckNameProps = {
  check: MergeCheck;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const ClassicMergeCheckName: FC<ClassicMergeCheckNameProps> = ({
  check,
}) => {
  const label = check.count ? (
    <strong>
      {check.count}
      {check.key === MergeCheckKey.MAXIMUM_COMMITS_BEHIND ? '' : '+'}
    </strong>
  ) : (
    <FormattedMessage
      {...(check.key === MergeCheckKey.FAILED_BUILDS ||
      check.key === MergeCheckKey.IN_PROGRESS_BUILDS
        ? messages.noLabel
        : messages.allLabel)}
      tagName="strong"
    />
  );

  return (
    <FormattedMessage
      {...classicCheckMessages[check.key].name}
      values={{
        count: check.count,
        label,
      }}
    />
  );
};
